import styled from "@emotion/styled";

import { setFullViewportWidthStyles } from "~/lib/styles";

export const TitleContainer = styled.div`
  margin-block: 17px;

  color: #001246;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
`;

export const ArticlesContainer = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr;
  gap: 4px;

  ${props => props.theme.breakpoints.up("tablet")} {
    grid-template-columns: 1fr 1fr;
  }
`;

export const ArticlePlaceholder = styled.div`
  display: none;

  background-color: #dfe6fa;
  ${props => props.theme.breakpoints.up("tablet")} {
    display: block;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;

  inline-size: 100%;
`;

export const Container = styled.div`
  ${props => props.theme.breakpoints.down("tablet")} {
    ${setFullViewportWidthStyles()}
  }
`;
